<section class="get-labels-label-ready" data-testid="get-labels-label-ready">
  @if (state() === 'processing') {
    <output class="visually-hidden" data-testid="get-labels-processing-status">
      {{ 'createShipment.getLabels.creatingLabel' | translate }}
    </output>
  }

  @if (isReady()) {
    <output data-testid="get-labels-ready-status">
      <puro-typography component="h3" variant="h3" class="get-labels-label-ready__title">
        {{ 'createShipment.getLabels.labelReadyTitle' | translate }}
      </puro-typography>
    </output>
  }

  <puro-typography component="p" variant="h4" class="get-labels-label-ready__pin">
    <span class="get-labels-label-ready__pin-label">
      {{ 'createShipment.getLabels.trackingPinLabel' | translate }}
    </span>
    <span class="get-labels-label-ready__pin-value">{{ trackingPin() }}</span>
  </puro-typography>

  <puro-typography component="p" variant="body1" class="get-labels-label-ready__instructions">
    {{ 'createShipment.getLabels.labelInstructionsBefore' | translate }}
    <a
      class="get-labels-label-ready__learn-how"
      [href]="'createShipment.getLabels.learnHowUrl' | translate"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ 'createShipment.getLabels.learnHow' | translate }}
    </a>
    {{ 'createShipment.getLabels.labelInstructionsAfter' | translate }}
  </puro-typography>

  @if (showGenerationError()) {
    <app-alert-toast severity="error" live="assertive" data-testid="get-labels-generation-error">
      <div class="get-labels-label-ready__generation-error-content">
        <puro-typography
          component="p"
          variant="body1"
          class="get-labels-label-ready__generation-error-title"
        >
          <strong>{{ 'createShipment.getLabels.labelGenerationErrorTitle' | translate }}</strong>
        </puro-typography>
        <puro-typography
          component="p"
          variant="body1"
          class="get-labels-label-ready__generation-error-body"
        >
          {{ 'createShipment.getLabels.labelGenerationErrorBody' | translate }}
          <strong class="get-labels-label-ready__generation-error-phone">{{
            'createShipment.getLabels.labelGenerationErrorPhone' | translate
          }}</strong
          >.
        </puro-typography>
      </div>
    </app-alert-toast>
  }

  <table
    class="get-labels-label-ready__table"
    [attr.aria-label]="'createShipment.getLabels.labelTableAria' | translate"
  >
    <thead>
      <tr class="get-labels-label-ready__header">
        <th class="get-labels-label-ready__col-document" scope="col">
          {{ 'createShipment.getLabels.documentColumn' | translate }}
        </th>
        <th class="get-labels-label-ready__col-instructions" scope="col">
          {{ 'createShipment.getLabels.instructionsColumn' | translate }}
        </th>
        <th class="get-labels-label-ready__col-print" scope="col">
          {{ 'createShipment.getLabels.printDownloadColumn' | translate }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr class="get-labels-label-ready__row">
        <td class="get-labels-label-ready__thumb">
          <img
            class="get-labels-label-ready__thumb-placeholder"
            src="assets/images/get-labels/Group.png"
            alt=""
            aria-hidden="true"
            width="100"
            height="138"
          />
        </td>
        <td class="get-labels-label-ready__affix">
          <puro-typography component="p" variant="body2">
            {{ 'createShipment.getLabels.affixLabelInstruction' | translate }}
          </puro-typography>
        </td>
        <td class="get-labels-label-ready__action-cell">
          <div class="get-labels-label-ready__action">
            <puro-button
              type="button"
              variant="primary"
              size="small"
              [loading]="state() === 'processing'"
              [disabled]="state() === 'processing'"
              [attr.aria-describedby]="state() === 'failed' ? failureStatusId : null"
              data-testid="get-labels-view-download"
              (buttonClick)="onAction()"
            >
              @if (state() !== 'processing') {
                <puro-icon name="arrow-down" size="sm" aria-hidden="true" />
                {{ 'createShipment.getLabels.viewDownload' | translate }}
              } @else {
                {{ 'createShipment.getLabels.creatingLabel' | translate }}
              }
            </puro-button>
            @if (state() === 'failed') {
              <output
                class="get-labels-label-ready__failure"
                data-testid="get-labels-label-failed"
                [attr.id]="failureStatusId"
              >
                <puro-typography component="p" variant="caption">
                  <strong>{{ 'createShipment.getLabels.labelFailed' | translate }}</strong>
                </puro-typography>
                <puro-typography component="p" variant="caption">
                  {{ 'createShipment.getLabels.retryLabel' | translate }}
                </puro-typography>
              </output>
            }
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</section>
